import Vue from "vue";
import VueRouter from "vue-router";
import ListClientPortails from "@/views/ListClientPortal.vue";
import { useLogin } from "@/composables/login";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: "portails",
  },
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/Login"),
  },
  {
    path: "/portails",
    name: "portails",
    component: ListClientPortails,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/portails/:id",
    name: "portail-details",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "client-portal" */ "../views/ShowClientPortal.vue"
      ),
  },
  {
    path: "/groupes",
    name: "groupes",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "groups" */ "../views/ListGroup.vue"),
  },
  {
    path: "/groupes/:id",
    name: "groupe-details",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "group-details" */ "../views/ShowGroup.vue"),
  },
  {
    path: "/partenaires",
    name: "partenaires",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "partenaires" */ "../views/ListPartner.vue"),
  },
  {
    path: "/partenaires/:id",
    name: "partenaire-details",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "partenaire-details" */ "../views/ShowPartner.vue"
      ),
  },
  {
    path: "/nas",
    name: "nas",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "nas" */ "../views/ListNas.vue"),
  },
  {
    path: "/nas/:id",
    name: "nas-details",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "nas-details" */ "../views/ShowNas.vue"),
  },

  {
    path: "/profils-portails/:id",
    name: "profils-portails",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "profils-details" */ "../views/ShowPortalProfile.vue"
      ),
  },
  {
    path: "/modeles-portails",
    name: "modeles-portails",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "portal-model" */ "../views/ListPortalModel.vue"
      ),
  },
  {
    path: "/modeles-portails/:id",
    name: "modeles-portails-details",
    meta: {
      requiresAuth: true,
    },

    component: () =>
      import(
        /* webpackChunkName: "portal-model-details" */ "../views/ShowPortalModel.vue"
      ),
  },
  {
    path: "/cartes/:id",
    name: "cartes-details",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "card-details" */ "../views/ShowCard.vue"),
  },
  {
    path: "/profils/:id",
    name: "profil-details",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "profil-details" */ "../views/ShowProfile"),
  },
  {
    path: "/logsradius-nas/:nasId",
    name: "logsradius-nas",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "logsradius-card" */ "../views/ListLogradius.vue"
      ),
  },
  {
    path: "/logsradius-card/:cardId",
    name: "logsradius-card",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "logsradius-card" */ "../views/ListLogradiusForCard.vue"
      ),
  },
  {
    path: "/transactions-cb",
    name: "transactions-cb",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "transactions-cb" */ "../views/ListCBTransaction.vue"
      ),
  },
  {
    path: "/transactions-pms",
    name: "transactions-pms",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "transactions-pms" */ "../views/ListPMSTransaction.vue"
      ),
  },
  {
    path: "/search-result/:term",
    name: "search-result",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "search-result" */ "../views/SearchResult.vue"
      ),
  },
  {
    path: "/authentifications-mac",
    name: "authentifications-mac",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "authentification-mac" */ "../views/ListAuthentificationMAC"
      ),
  },
  {
    path: "/card-editions",
    name: "card-editions",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "card-editions" */ "../views/ListCardEditions"
      ),
  },
  {
    path: "/card-editions/:id",
    name: "card-editions-details",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "card-editions" */ "../views/ShowCardEdition"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const { checkLoginOnLoad } = useLogin();

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const token = localStorage.getItem("token");
    const sessionInfos = localStorage.getItem("sessionInfos");
    if (
      token == null ||
      token == "" ||
      sessionInfos == null ||
      !checkLoginOnLoad()
    ) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
